module.exports = __webpack_public_path__ + "1a3b44d40c837aa9a709692d383c3c58.svg";